// import RewardBronze from "images/reward-bronze.svg";
// import RewardGold from "images/reward-gold.svg";
// import RewardPlatinum from "images/reward-platinum.svg";
// import RewardSilver from "images/reward-silver.svg";
// import RewardStarter from "images/reward-starter.svg";
// import StarIcon from "images/star.svg";
import { CommonOutletTemplate } from "UI/CommonOutletTemplate";
import * as FP from "utils/fp-js";
import { useDashboard } from "./Dashboard.hook";
import { EndIcon } from "./Dashboard.style";
import { ReferralButton } from "./ReferralButton";
import { SmallReferralButton } from "./SmallReferralButton";
import OneColModeIcon from "images/one-col-mode-icon.svg";
import TwoColsModeIcon from "images/two-cols-mode-icon.svg";
import { ButtonAdder } from "./ButtonAdder";
import { SenderAssignmentDialog } from "./SenderAssignmentDialog";
import { NewButtonDialog } from "./NewButtonDialog";

export const NUMBER_OF_LEVELS = Object.keys(EndIcon).length;
export const REFERRALS_IN_LEVEL = 50;

export const STARTER_MAX_PROGRESS = 20;
export const BRONZE_MAX_PROGRESS = 40;
export const SILVER_MAX_PROGRESS = 60;
export const GOLD_MAX_PROGRESS = 80;

export const mobileModes = {
  Profile: "Profile",
  Awards: "Awards",
  Dashboard: "Dashboard",
};

export const getUserLevel = (progress) =>
  FP.match(true)
    .on(progress >= 100, "Daimond")
    .on(progress >= GOLD_MAX_PROGRESS, "Platinum")
    .on(progress >= SILVER_MAX_PROGRESS, "Gold")
    .on(progress >= BRONZE_MAX_PROGRESS, "Silver")
    .on(progress >= STARTER_MAX_PROGRESS, "Bronze")
    .otherwise("Starter");

export const getUserPosition = (progress) =>
  FP.match(true)
    .on(progress >= 100, 5)
    .on(progress >= GOLD_MAX_PROGRESS, 10)
    .on(progress >= SILVER_MAX_PROGRESS, 20)
    .on(progress >= BRONZE_MAX_PROGRESS, 30)
    .on(progress >= STARTER_MAX_PROGRESS, 35)
    .otherwise(100);

export const getUserProgress = (referralsCount) =>
  (referralsCount * 100) / (REFERRALS_IN_LEVEL * NUMBER_OF_LEVELS);

export const MyButtons = () => {
  const {
    loading,
    setError,
    buttonLocations,
    // progress,
    logos,
    modes,
    oneColMode,
    toggleColMode,
    showWarning,
    hideWarning,
    setNewProgress,
    setNewLevel,
    setNewCountsForUpdate,
    setLevelProgress,
    originator,
    senders,
    currentButton,
    setCurrentButton,
    updateSendersInButtonLocations,
    addNewSender,
    providers,
    isButtonAdderOpen,
    setIsButtonAdderOpen,
    reloadButtons,
    addNewProvider,
  } = useDashboard();

  const selectNewlyAddedSender = (sender) => {
    addNewSender(sender);
    const senderId = sender?.id;
    if (!senderId) return;
    const currentButtonId = Object.keys(currentButton)[0];
    const newButtonLocations = buttonLocations.map((buttonLocation) => {
      const buttonLocationId = Object.keys(buttonLocation)[0];

      if (buttonLocationId === currentButtonId) {
        return {
          [buttonLocationId]: {
            ...buttonLocation[buttonLocationId],
            senders: [...buttonLocation[buttonLocationId].senders, sender],
          },
        };
      }
      return buttonLocation;
    });
    updateSendersInButtonLocations(newButtonLocations);
  };

  return (
    <CommonOutletTemplate title="My Button Dashboard" isLoading={loading}>
      <div className="relative flex flex-row justify-end items-center">
        <img
          src={oneColMode ? TwoColsModeIcon : OneColModeIcon}
          alt="one row mode"
          className="absolute -top-7 right-0 cursor-pointer hover:opacity-80 block md:hidden"
          onClick={() => toggleColMode(!oneColMode)}
          title={oneColMode ? "Two columns mode" : "One column mode"}
        />
      </div>
      {/* <div
        className={`bg-gray-100 rounded-xl px-10 py-4 mb-4
          hidden gap-6 md:flex flex-row justify-between items-center`}
      >
        <div className="flex-1 text-lg text-gray-600">
          <div className="flex flex-row items-center text-lg font-bold text-black">
            <img src={StarIcon} alt="star icon" className="w-6" />
            My Rewards
          </div>
          Your progress is displayed here, keep it up!
        </div>
        <div className="flex flex-row items-center gap-4 text-lg font-bold text-black">
          <img src={RewardStarter} alt="reward starter" className="w-14" />
          {progress > STARTER_MAX_PROGRESS && (
            <img src={RewardBronze} alt="reward bronze" className="w-14" />
          )}
          {progress > BRONZE_MAX_PROGRESS && (
            <img src={RewardSilver} alt="reward silver" className="w-14" />
          )}
          {progress > SILVER_MAX_PROGRESS && (
            <img src={RewardGold} alt="reward gold" className="w-14" />
          )}
          {progress > GOLD_MAX_PROGRESS && (
            <img src={RewardPlatinum} alt="reward platinum" className="w-14" />
          )}
        </div>
      </div> */}
      <div
        className={
          "hidden mt-3 flex-1 md:flex flex-wrap gap-6 gap-y-3 sm:gap-10 justify-center xl:justify-start items-start"
        }
      >
        {buttonLocations?.map((buttonLocation, index) => (
          <ReferralButton
            key={JSON.stringify(buttonLocation)}
            data={buttonLocation}
            setError={setError}
            logo={logos[index]}
            mode={modes[index]}
            setNewProgress={setNewProgress}
            setNewLevel={setNewLevel}
            setNewCountsForUpdate={setNewCountsForUpdate}
            setLevelProgress={setLevelProgress}
            showWarning={showWarning}
            hideWarning={hideWarning}
            originator={originator}
            setCurrentButton={setCurrentButton}
            providers={providers}
          />
        ))}
        <ButtonAdder setIsButtonAdderOpen={setIsButtonAdderOpen} />
      </div>
      {oneColMode ? (
        <div
          className={
            "flex-1 mt-4 flex flex-row gap-8 gap-y-6 flex-wrap justify-center items-start md:hidden"
          }
        >
          {buttonLocations?.map((buttonLocation, index) => (
            <ReferralButton
              key={JSON.stringify(buttonLocation)}
              data={buttonLocation}
              setError={setError}
              logo={logos[index]}
              mode={modes[index]}
              setNewProgress={setNewProgress}
              setNewLevel={setNewLevel}
              setNewCountsForUpdate={setNewCountsForUpdate}
              setLevelProgress={setLevelProgress}
              showWarning={showWarning}
              hideWarning={hideWarning}
              originator={originator}
              setCurrentButton={setCurrentButton}
              providers={providers}
            />
          ))}
          <ButtonAdder setIsButtonAdderOpen={setIsButtonAdderOpen} oneColMode />
        </div>
      ) : (
        <div
          className={
            "flex-1 mt-4 flex flex-row gap-8 gap-y-6 flex-wrap justify-center items-start md:hidden"
          }
        >
          {buttonLocations?.map((buttonLocation, index) => (
            <SmallReferralButton
              key={JSON.stringify(buttonLocation)}
              data={buttonLocation}
              setError={setError}
              logo={logos[index]}
              mode={modes[index]}
              setNewProgress={setNewProgress}
              setNewLevel={setNewLevel}
              setNewCountsForUpdate={setNewCountsForUpdate}
              setLevelProgress={setLevelProgress}
              showWarning={showWarning}
              hideWarning={hideWarning}
              originator={originator}
              setCurrentButton={setCurrentButton}
              providers={providers}
            />
          ))}
          <ButtonAdder setIsButtonAdderOpen={setIsButtonAdderOpen}/>
        </div>
      )}
      {isButtonAdderOpen && (
        <NewButtonDialog
          handleClose={() => setIsButtonAdderOpen(false)}
          setError={setError}
          showWarning={showWarning}
          originator={originator}
          reloadButtons={reloadButtons}
          providers={providers}
          addNewProvider={addNewProvider}
        />
      )}
      {!!currentButton && (
        <SenderAssignmentDialog
          handleClose={() => setCurrentButton(null)}
          senders={senders}
          currentButton={currentButton}
          originator={originator}
          setError={setError}
          updateSendersInButtonLocations={updateSendersInButtonLocations}
          selectNewlyAddedSender={selectNewlyAddedSender}
        />
      )}
    </CommonOutletTemplate>
  );
};
